import { Component } from '@angular/core';

@Component({
  selector: 'app-account-settings-icons',
  templateUrl: './account-settings-icons.component.html',
  styles: [],
  standalone: false,
})
export class AccountSettingsIconsComponent {
  constructor() {}
}
